import { Tokenizer } from '@fnv-core/tokens';
import * as React from 'react';
import { LOGIN_URL } from '../constants/Constants';

const LOGIN_URL_TEMPLATE = `${LOGIN_URL}?redirectUrl={0}`;

export interface LoginRedirectProps {
  formFieldDefinition: any;
}

export const LoginRedirect = (props: LoginRedirectProps) => {
  const { formFieldDefinition } = props;
  const redirectUrl = location.pathname + location.search;
  const href = Tokenizer.replaceTokens(LOGIN_URL_TEMPLATE, [redirectUrl]);

  return (
    <div className="form-group login-redirect">
      <p>
        {formFieldDefinition.label}
        <br/>
        <a href={href}>{formFieldDefinition.linkText}</a>
      </p>
    </div>
  );
};